(function () {
    'use strict';

    angular
        .module('app')
        .controller('LinePlanCreateController', lController);

    function lController($scope, $http, $cookies, $location, $rootScope, $timeout, $interval, $state,
        LinePlanService, UserService, SeasonService, WorkflowService, toaster, SharedData, cfpLoadingBar) {
        var model = this;
        model.linePlans = [];
        model.LinePlanCreate = "";
        model.subSeasonEndDate = "";
        model.subSeason2EndDate = "";
        model.newLinePlan = {};

        $scope.permissionDenied = function () {
            $state.go('permissionDenied');
        }

        $scope.goToUserPage = function (data) {
            $state.go(data.pageName, data.params);
        }

        $scope.loaderClosed = function () {
            cfpLoadingBar.complete();
        }

        $scope.loaderStart = function () {
            cfpLoadingBar.start();
        }

        angular.forEach($rootScope.userPermissions, function (userPermissionRow) {
            if (userPermissionRow[0] == 1) {
                if (userPermissionRow[1] == 3) {
                    model.LinePlanCreate = true;
                }
                if (userPermissionRow[1] == 2) {
                    model.LinePlanEdit = true;
                }
            }
        });

        if (model.LinePlanCreate !== true) {
            $state.go('permissionDenied');
        }

        $scope.validateAccountable = function (obj, prop) {
            if (!obj) return;

            prop = prop || "Responsible";

            //If its not an object or doesn't have the correct property theres nothing we can do.
            if (typeof obj !== "object" || !obj.hasOwnProperty(prop)) {
                return;
            }

            //If it doesn't look like a user (has an Id property with a value > 0) we will set the prop to null;
            //Otherwise it will pass.
            if (!obj[prop].hasOwnProperty("Id") || obj[prop].Id <= 0) {
                obj[prop] = null;
            }
        };

        model.checkLinePlanName = function () {
            var linePlanName = model.newLinePlan.linePlanName;
            if (model.newLinePlan.selectedBrand && model.newLinePlan.selectedSeason) {
                toaster.clear();
                LinePlanService.isLinePlanNameExists(0, linePlanName, model.newLinePlan.selectedBrand, model.newLinePlan.selectedSeason)
                    .then(function (response) {
                        if (response == true) {
                            toaster.pop({
                                type: 'note',
                                title: 'Name duplication',
                                body: 'You may continue, but please note this name already exists.',
                                timeout: 5000
                            });
                        }
                    });
            }
        }

        model.createLinePlan = function (isFormInvalid) {
            if (!isFormInvalid) {
                $scope.linePlanCreateForm.$setPristine();

                var linePlanName = model.newLinePlan.linePlanName;
                var brandId = model.newLinePlan.selectedBrand;
                var seasonId = model.newLinePlan.selectedSeason;
                var userId = model.newLinePlan.Responsible.Id;
                var wfGroupId = model.newLinePlan.selectedGroup.WFGroupId;

                model.linePlan = { LinePlanName: linePlanName, BrandId: brandId, SeasonId: seasonId, ResponsibleId: userId, WFGroupId: wfGroupId };
                model.calendarData = [];

                for (var i = 0; i < model.subSeasons.length; i++) {
                    model.calendarData.push({ SubSeasonId: model.subSeasons[i].SubSeasonId /*, EndDate: getEndDate*/ });
                }

                LinePlanService.createLinePlan(model.linePlan, model.calendarData)
                    .then(function (response) {
                        if (response.ResponseMessage == 'success') {
                            toaster.pop({
                                type: 'success',
                                title: 'Success!',
                                body: 'Line Plan Successfully Created',
                                timeout: 5000
                            });

                            $state.go("linePlan", { linePlanId: response.LinePlanId });
                        }
                        else {
                            toaster.pop({
                                type: 'error',
                                title: 'Error!',
                                body: response.ResponseMessage,
                                timeout: 5000
                            });
                            $scope.linePlanCreateForm.$setPristine();
                            $scope.linePlanCreateForm.$setUntouched();
                        }
                    }, function (error, status) {
                        toaster.pop({
                            type: 'error',
                            title: 'Error!',
                            body: 'There was an error. Please contact your system administrator',
                            timeout: 5000
                        });
                        $scope.linePlanCreateForm.$setPristine();
                        $scope.linePlanCreateForm.$setUntouched();
                    });
            } else {
                toaster.pop({
                    type: 'error',
                    title: 'Error!',
                    body: 'Please review all fields indicated in red',
                    timeout: 5000
                });
            }
        }

        function getUsersByBrand(brandId) {
            UserService.getUsersByBrand(brandId).then(function (data) {
                model.users = data;
            });
        }

        function getBrands() {
            SharedData.getUserDefaults().then(function (response) {
                if (response) {
                    model.brands = response.brands;
                    model.seasons = response.seasons;
                    model.newLinePlan.selectedBrand = response.brandId;
                    model.newLinePlan.selectedSeason = response.seasonId;

                    if (response.brandId) {
                        model.selectBrand(response.brandId);
                    }

                    if (response.seasonId) {
                        model.getSubSeasonNames();
                    }
                }
                cfpLoadingBar.complete();
            });
        }

        function getSeasons(brandId) {
            LinePlanService.getAvailableSeasons(brandId).then(function (data) {
                model.seasons = data;
            });
        }

        function getWFGroups(brandId) {
            WorkflowService.getWFGroups(brandId, 1).then(function (data) {
                model.groups = data;
            });
        }

        //getBrands();

        model.selectBrand = function(brandId) {
            model.newLinePlan.selectedUser = "";
            getUsersByBrand(brandId);
            getWFGroups(brandId);
            getSeasons(brandId);
        };

        model.getSubSeasonNames = function () {
            if (model.newLinePlan.selectedSeason) {
                SeasonService.getSubSeasons(model.newLinePlan.selectedSeason).then(function (data) {
                    model.subSeasons = data;
                });

            }
        }

        model.disabled = function (date, mode) {
            var retValue = false;
            try {
                retValue = (mode === 'day' && (date.getDay() === 0 || date.getDay() === 6));
                if (!retValue) {
                    var dt = $filter('date')(date, "MM/dd/yyyy");
                    angular.forEach(linePlanDisableDates, function (d) {
                        if (d == dt) {
                            retValue = true;
                        }
                    });
                }
            } catch (e) { }
            return retValue;
        };
    }

})();
